import script from "./Seat.vue?vue&type=script&setup=true&lang=js"
export * from "./Seat.vue?vue&type=script&setup=true&lang=js"

import "./Seat.vue?vue&type=style&index=0&id=5ad97825&lang=scss"
import "./Seat.vue?vue&type=style&index=1&id=5ad97825&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad97825"]])

export default __exports__